import { ImageProps } from "@omni/types/components/props/image.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

type ImageContextValue = ImageProps;

type ImageContextProviderProps = RequireChildrenFor<ImageProps>;

export const ImageContext = createContext<ImageContextValue | undefined>(
    undefined
);
ImageContext.displayName = "ImageContext";

export const ImageContextProvider = ({
    children,
    ...props
}: ImageContextProviderProps) => {
    return <ImageContext value={props}>{children}</ImageContext>;
};

export const useImageContext = () => {
    const context = use<ImageContextValue | undefined>(ImageContext);

    if (!isDefined(context)) {
        throw new Error(`${ImageContext.displayName} is undefined.`);
    }

    return context;
};
